import { FC } from "react";
import styles from "../../styles/common/ReadTime.module.scss";
import contactsSvg from "../../utils/svg-icon/contacts";

const ReadTime: FC<{
    time: string;
    className?: string;
}> = ({ time, className }) => {
    const { ClockLine } = contactsSvg;

    return (
        <span
            className={`d-flex align-items-center ${styles.readTime} ${className}`}
        >
            <ClockLine />
            <span className={`${styles.textSubTitle}`}>
                Estimated read time: {time} minutes
            </span>
        </span>
    );
};

export default ReadTime;
